/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import PropTypes from 'prop-types'
import TwentyTwenty from 'react-twentytwenty'
import { Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function TwentytwentyPreview({ srcs }) {
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []
  const leftImage =
    validImages[0]?.file instanceof File
      ? URL.createObjectURL(validImages[0].file)
      : validImages[0]?.file || ''
  const rightImage =
    validImages[1]?.file instanceof File
      ? URL.createObjectURL(validImages[1].file)
      : validImages[1]?.file || ''

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {validImages.length >= 2 && (
        <TwentyTwenty
          left={
            <img
              className="d-flex w-100"
              src={leftImage}
              alt="Left"
              style={{ objectFit: 'cover', height: '20%' }}
            />
          }
          right={
            <img
              className="d-flex w-100"
              src={rightImage}
              alt="Right"
              style={{ objectFit: 'cover', height: '20%' }}
            />
          }
          slider={
            <>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: '50%',
                  width: '2px',
                  backgroundColor: 'white',
                  transform: 'translateX(-50%)',
                  zIndex: 4,
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.3)',
                }}
              />
              <div
                className="twentytwenty-handle"
                style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                  border: '2px solid white',
                  borderRadius: '50%',
                  cursor: 'ew-resize',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                  }}
                >
                  <div
                    style={{
                      width: '0',
                      height: '0',
                      borderTop: '8px solid transparent',
                      borderBottom: '8px solid transparent',
                      borderRight: '10px solid white',
                    }}
                  />
                  <div
                    style={{
                      width: '0',
                      height: '0',
                      borderTop: '8px solid transparent',
                      borderBottom: '8px solid transparent',
                      borderLeft: '10px solid white',
                    }}
                  />
                </div>
              </div>
              <CIIcon />
            </>
          }
        />
      )}

      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

TwentytwentyPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
}

TwentytwentyPreview.defaultProps = {
  srcs: [],
}

export default TwentytwentyPreview
